import './single-job-offer.scss';
import { handleFileUpload } from '../../../../assets/src/ts/utils/file-upload';

handleFileUpload();
